import FalconComponentCard from "components/common/FalconComponentCard";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CliamsListFilter from "./components/CliamsListFilter";
import CliamsInformations from "./components/CliamsInformations";
import ClaimListTable from "./components/ClaimListTable";
import {
  handleResetCreateClaim,
  handleResetFilter,
  handleResetServices,
  setSelectedService,
  handleClaimFilter,
} from "./config/claimSlice";
import {
  ClaimDeleteReport,
  ClaimServiceReport,
  CreateGssReports,
  CreateTaxInvoiceReports,
  GetAllClaimsList,
} from "./config/cliamApi";
import moment from "moment";
import { handleResetAll } from "features/preauthorization/config/preauthorizationSlice";
import { toast } from "react-toastify";
import { FiDownloadCloud } from "react-icons/fi";
import { FaFileExcel } from "react-icons/fa";
import { BsFilePdf } from "react-icons/bs";
import { handleDownloadXLSX } from "helpers/excel";
import PrintComponent from "components/common/custom/print/PrintComponents.js";
import ClaimGssReportPdf from "./components/ClaimTaxInvoicePdf";
import TaxInvoicePdf from "./components/TaxInvoicePdf";
import WizardModal from "components/wizard/WizardModal";

const Cliams = () => {
  const dispatch = useDispatch();
  const { claimListData, claimFilters, selectedTableRow } = useSelector(
    (state) => state.claim,
  );
  const { userData } = useSelector((state) => state.auth);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims",
  );

  const [total, setTotal] = useState(null);
  const [statusCounts, setStatusCounts] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [showTax, setShowTax] = useState(false);
  const [showGss, setShowGss] = useState(false);
  const [gssData, setGssData] = useState(null);
  const [taxData, setTaxData] = useState(null);
  const [gssDescription, setGssDescription] = useState(null);
  const [gssError, setGssError] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    control,
    watch,
    formState: { errors, isSubmitted },
    handleSubmit,
    reset,
    setError,
    setValue,
    clearErrors,
  } = useForm({
    defaultValues: {
      payer: "",
      insurance: "",
      patient: "",
      start_date: "",
      end_date: "",
      bundle_request_id: "",
      claim_type: "",
      claim_sub_type: "",
      branch: "",
      cliam_status: "",
      claimid: "",
      specialities: "",
      second_response: "",
      identity_type: "",
      doctors: "",
      communication: false,
    },
  });

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));
  const navigate = useNavigate();

  const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
    branch_id:
      claimFilters?.branch?.branch_id ||
      selectedBranch?.branch_id ||
      selectedBranch?.value ||
      "",
    payer_id: claimFilters?.payer?.payer_id || "",
    insurance_company_id: claimFilters?.insurance?.insurance_company_id || "",
    claim_type: claimFilters?.claim_type?.claim_types_id || "",
    claimsub_types_name: claimFilters?.claim_sub_type?.claimsub_types_id || "",
    bndle_reqid: claimFilters?.bundle_request_id || "",
    frm_dte: claimFilters?.start_date
      ? moment(claimFilters?.start_date).format("YYYY-MM-DD")
      : "",
    to_dte: claimFilters?.end_date
      ? moment(claimFilters?.end_date).format("YYYY-MM-DD")
      : "",
    claimid: claimFilters?.claimid || "",
    is_communication: claimFilters?.communication || false,
    is_secondresponse: claimFilters?.second_response || false,
    ident_typ: claimFilters?.identity_type?.ident_type_id || "",
    pat_det: claimFilters?.patient || "",
    claim_sts: claimFilters?.cliam_status?.allstatus_code || "",
    start_point: customPage,
    limit: customLimit,
  });

  const fetchCliamsList = async (body = {}) => {
    try {
      const response = await dispatch(GetAllClaimsList(body)).unwrap();
      const claims = response?.data?.claim_data || [];
      const totals = claims.reduce(
        (acc, claim) => {
          acc.net += parseFloat(claim.netamount) || 0;
          acc.gross += parseFloat(claim.grossamount) || 0;
          acc.vat += parseFloat(claim.vatamnt) || 0;
          acc.submitted += parseFloat(claim.submtamount) || 0;
          acc.deductible += parseFloat(claim.patshreamount) || 0;
          acc.discount += parseFloat(claim.discamnt) || 0;
          acc.approved += parseFloat(claim.apprveamount || 0) || 0;
          return acc;
        },
        {
          net: 0,
          gross: 0,
          vat: 0,
          submitted: 0,
          deductible: 0,
          discount: 0,
          approved: 0,
        },
      );
      const counts = claims.reduce((acc, claim) => {
        const status = claim?.claim_status?.toLowerCase() || "unknown";
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});

      setTotal(totals);
      setStatusCounts(counts);
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };

  const handleDownloadClaimExcel = async () => {
    const excelBody = {
      branch_id:
        claimFilters?.branch?.branch_id ||
        selectedBranch?.branch_id ||
        selectedBranch?.value ||
        "",
      payer_id: claimFilters?.payer?.payer_id || "",
      insurance_company_id: claimFilters?.insurance?.insurance_company_id || "",
      claim_type: claimFilters?.claim_type?.claim_types_id || "",
      claimsub_types_name:
        claimFilters?.claim_sub_type?.claimsub_types_id || "",
      bndle_reqid: claimFilters?.bundle_request_id || "",
      frm_dte: claimFilters?.start_date
        ? moment(claimFilters?.start_date).format("YYYY-MM-DD")
        : "",
      to_dte: claimFilters?.end_date
        ? moment(claimFilters?.end_date).format("YYYY-MM-DD")
        : "",
      is_communication: claimFilters?.communication || false,
      is_secondresponse: claimFilters?.second_response || false,
      ident_typ: claimFilters?.identity_type?.ident_type_id || "",
      pat_det: claimFilters?.patient || "",
      claim_sts: claimFilters?.cliam_status?.allstatus_code || "",
      start_point: 0,
      limit: totalRows,
    };
    const response = await dispatch(GetAllClaimsList(excelBody)).unwrap();

    const data = response?.data?.claim_data;

    const flattenedArray =
      data &&
      data.length > 0 &&
      data.map((row, index) => [
        index + 1 || "",
        row?.insurance_direct === 0
          ? `${row?.payer_name} - ${row?.insurance_shname}`
          : row?.payer_name || "",
        row?.prov_name || "",
        row?.claimfull_id || "",
        row?.patient_mrn || "",
        `${row?.patient_firstname || ""} ${row?.patient_familyname || ""}`,
        row?.patient_identifier || "",
        row?.patient_nationalid || "",
        row?.polcyno || "", // policy number
        row?.polcyname || "", // policy number
        row?.classname || "", // policy number
        row?.memberid || "", // member id
        row?.claim_date ? moment(row?.claim_date).format("DD-MM-YYYY") : "",
        row?.crteam_spclty || "",
        row?.practitioner_name || "",
        Number(row?.grossamount) || 0,
        Number(row?.discamnt) || 0,
        Number(row?.patshreamount) || 0,
        Number(row?.netamount) || 0,
        Number(row?.vatamount) || 0,
        Number(row?.netvatamount) || 0,
        Number(row?.submtamount) || 0,
        Number(row?.apprveamount) || 0,
        row?.clm_status,
        row?.remarks?.map((item) => item?.claimerr_display)?.join(" , "),
        row?.disposition || "",
        row?.bndle_reqid || "",
        row?.resp_bundleid || "", // bundle response id
      ]);

    handleDownloadXLSX(
      [
        [
          "#",
          "Payer Name",
          "Provider Name",
          "Claim Number",
          "File Number",
          "Patient Name",
          "Patient Identifier Type",
          "Patient Identifier",
          "Policy Number",
          "Policy Holder Name",
          "Class Name",
          "Membership No",
          "Claim Date",
          "Speciality",
          "Doctor Name",
          "Gross Amount",
          "Discount",
          "Deductible Amount",
          "Net Amount",
          "Vat Amount",
          "NetAmount+Vat",
          "Submitted Amount",
          "Approved Amount",
          "Status",
          "Disposition",
          "Rejection Reason",
          "Bundle RequestId",
          "Bundle ResponseId",
        ],
        ...(flattenedArray || []), // ✅ Correctly spread the data
      ],
      `Claim_List_Export_${moment().format("DD-MM-YYYY_hh:mm:ss")}`,
    );
  };
  const handleDownloadClaimServiceExcel = async () => {
    const excelBody = {
      branch_id:
        claimFilters?.branch?.branch_id ||
        selectedBranch?.branch_id ||
        selectedBranch?.value ||
        "",
      payer_id: claimFilters?.payer?.payer_id || "",
      insurance_company_id: claimFilters?.insurance?.insurance_company_id || "",
      claim_type: claimFilters?.claim_type?.claim_types_id || "",
      claimsub_types_name:
        claimFilters?.claim_sub_type?.claimsub_types_id || "",
      claimid: claimFilters?.claimid || "",
      bndle_reqid: claimFilters?.bundle_request_id || "",
      frm_dte: claimFilters?.start_date
        ? moment(claimFilters?.start_date).format("YYYY-MM-DD")
        : "",
      to_dte: claimFilters?.end_date
        ? moment(claimFilters?.end_date).format("YYYY-MM-DD")
        : "",
      ident_typ: claimFilters?.identity_type?.ident_type_id || "",
      pat_det: claimFilters?.patient || "",
      start_point: 0,
      limit: 500000,
    };

    const response = await dispatch(ClaimServiceReport(excelBody)).unwrap();

    const data = response?.data?.claim_data || [];

    let maxDiags = 1;
    if (data && data.length > 0) {
      data.forEach((row) => {
        if (row?.serv_diag) {
          const diags = String(row.serv_diag)
            .split(",")
            .map((d) => d.trim())
            .filter(Boolean);
          if (diags.length > maxDiags) maxDiags = diags.length;
        }
      });
    }

    const diagHeaders = [];
    if (maxDiags === 1) {
      diagHeaders.push("Diagnosis Code");
    } else {
      for (let i = 1; i <= maxDiags; i++) {
        diagHeaders.push(`Diagnosis Code ${i}`);
      }
    }

    const flattenedArray =
      data &&
      data.length > 0 &&
      data.map((row, index) => {
        const diags = row?.serv_diag
          ? String(row.serv_diag)
              .split(",")
              .map((d) => d.trim())
              .filter(Boolean)
          : [];
        const diagColumns = [];
        for (let i = 0; i < maxDiags; i++) {
          diagColumns.push(diags[i] || "");
        }

        return [
          index + 1,
          row?.insurance_direct === 0
            ? `${row?.payer_name} - ${row?.insurance_shname}`
            : row?.payer_name || "",
          row?.prov_name || "",
          row?.claimfull_id || "",
          row?.patient_mrn || "",
          `${row?.patient_firstname || ""} ${row?.patient_familyname || ""}`,
          row?.patient_identifier || "",
          row?.patient_nationalid || "",
          row?.polcyno || "",
          row?.polcyname || "",
          row?.classname || "",
          row?.memberid || "",
          row?.claim_date ? moment(row?.claim_date).format("DD-MM-YYYY") : "",
          row?.crteam_spclty || "",
          row?.practitioner_name || "",
          row?.nphiescode || "",
          row?.nphiesname || "",
          row?.unitprice || 0,
          row?.quantity || 0,
          Number(row?.quantity || 0) * Number(row?.unitprice || 0),
          row?.discountamount || 0,
          row?.patientshare || 0,
          Number(row?.quantity || 0) * Number(row?.unitprice || 0) -
            Number(row?.discountamount || 0) -
            Number(row?.patientshare || 0),
          row?.taxamount || "",
          Number(row?.quantity || 0) * Number(row?.unitprice || 0) -
            Number(row?.discountamount || 0) -
            Number(row?.patientshare || 0) +
            Number(row?.taxamount || 0),
          Number(row?.quantity || 0) * Number(row?.unitprice || 0) -
            Number(row?.discountamount || 0) -
            Number(row?.patientshare || 0) +
            Number(row?.taxamount || 0) +
            Number(row?.patientshare || 0),
          Number(row?.apprveamount || 0),
          row?.clm_status || "",
          row?.remarks?.claimerr_display || "",
          ...diagColumns,
          row?.disposition || "",
          row?.bndle_reqid || "",
          row?.resp_bundleid || "",
        ];
      });

    handleDownloadXLSX(
      [
        [
          "#",
          "Payer Name",
          "Provider Name",
          "Claim Number",
          "File Number",
          "Patient Name",
          "Patient Identifier Type",
          "Patient Identifier",
          "Policy Number",
          "Policy Holder Name",
          "Class Name",
          "Membership No",
          "Claim Date",
          "Speciality",
          "Doctor Name",
          "Service Code",
          "Ser Description",
          "Unit Price",
          "Quantity",
          "Gross Amount",
          "Discount",
          "Deductible Amount",
          "Net Amount",
          "VAT Amount",
          "NetAmount+Vat",
          "Submitted Amount",
          "Approved Amount",
          "Status",
          "Disposotion",
          ...diagHeaders,
          "Rejection Reason",
          "Bundle RequestId",
          "Bundle ResponseId",
        ],
        ...(flattenedArray || []), // ✅ Correctly spread the data
      ],
      `Claim_service_Report_Export_${moment().format("DD-MM-YYYY_hh:mm:ss")}`,
    );
  };
  const handleDownloadDeletedServiceExcel = async () => {
    const excelBody = {
      branch_id:
        claimFilters?.branch?.branch_id ||
        selectedBranch?.branch_id ||
        selectedBranch?.value ||
        "",
      payer_id: claimFilters?.payer?.payer_id || "",
      insurance_company_id: claimFilters?.insurance?.insurance_company_id || "",
      claim_type: claimFilters?.claim_type?.claim_types_id || "",
      claimsub_types_name:
        claimFilters?.claim_sub_type?.claimsub_types_id || "",
      bndle_reqid: claimFilters?.bundle_request_id || "",
      frm_dte: claimFilters?.start_date
        ? moment(claimFilters?.start_date).format("YYYY-MM-DD")
        : "",
      to_dte: claimFilters?.end_date
        ? moment(claimFilters?.end_date).format("YYYY-MM-DD")
        : "",
      ident_typ: claimFilters?.identity_type?.ident_type_id || "",
      pat_det: claimFilters?.patient || "",
      start_point: 0,
      limit: 50000,
    };
    const response = await dispatch(ClaimDeleteReport(excelBody)).unwrap();
    const data = response?.data?.claim_data || [];
    const flattenedArray =
      data &&
      data.length > 0 &&
      data.map((row, index) => [
        index + 1 || "",
        row?.insurance_direct === 0
          ? `${row?.payer_name} - ${row?.insurance_shname}`
          : row?.payer_name || "",
        row?.prov_name || "",
        row?.claimfull_id || "",
        row?.patient_mrn || "",
        `${row?.patient_firstname || ""} ${row?.patient_familyname || ""}`,
        row?.patient_identifier || "",
        row?.patient_nationalid || "",
        row?.polcyno || "",
        row?.polcyname || "",
        row?.classname || "",
        row?.memberid || "",
        row?.claim_date ? moment(row?.claim_date).format("DD-MM-YYYY") : "",
        row?.crteam_spclty || "",
        row?.practitioner_name || "",
        Number(row?.grossamount) || 0,
        Number(row?.discamnt) || 0,
        Number(row?.patshreamount) || 0,
        Number(row?.netamount) || 0,
        Number(row?.vatamnt) || 0,
        Number(row?.netvatamount) || 0,
        Number(row?.subamnt) || 0,
        row?.clm_status,
        row?.bndle_reqid || "",
      ]);

    handleDownloadXLSX(
      [
        [
          "#",
          "Payer Name",
          "Provider Name",
          "Claim Number",
          "File Number",
          "Patient Name",
          "Patient Identifier Type",
          "Patient Identifier",
          "Policy Number",
          "Policy Holder Name",
          "Class Name",
          "Membership No",
          "Claim Date",
          "Speciality",
          "Doctor Name",
          "Gross Amount",
          "Discount",
          "Deductible Amount",
          "Net Amount",
          "Vat Amount",
          "NetAmount+Vat",
          "Submitted Amount",
          "Status",
          "Bundle RequestId",
        ],
        ...(flattenedArray || []), // ✅ Correctly spread the data
      ],
      `Claim_Delete_Report_${moment().format("DD-MM-YYYY_hh:mm:ss")}`,
    );
  };
  const handleGssReport = async () => {
    if (!selectedTableRow || selectedTableRow.length === 0) {
      let hasFieldErrors = false;

      let requiredFields = [
        "payer",
        "insurance",
        "start_date",
        "end_date",
        "claim_type",
      ];

      if (userData?.employee?.syspri_id === 1) {
        requiredFields.push("branch");
      }

      requiredFields.forEach((field) => {
        const value = watch(field);
        if (!value) {
          setError(field, {
            type: "manual",
            message: `${field.replace("_", " ")} is required`,
          });
          hasFieldErrors = true;
        }
      });

      if (hasFieldErrors) {
        toast.error("Please fill required fields before generating GSS report");
        return;
      } else {
        const excelBody = requestBody(page, totalRows);
        const response = await dispatch(GetAllClaimsList(excelBody)).unwrap();
        const allClaims = response?.data?.claim_data || [];

        const gssBody = {
          branch_id:
            claimFilters?.branch?.branch_id ||
            selectedBranch?.branch_id ||
            selectedBranch?.value ||
            "",
          insurance_company_id:
            claimFilters?.insurance?.insurance_company_id || "",
          claim_type: claimFilters?.claim_type?.claim_types_id || "",
          claimsub_types_name:
            claimFilters?.claim_sub_type?.claimsub_types_id || "",
          claim_data: allClaims?.map((item) => ({
            claimid: item?.claimid || "",
            claim_type: item?.claim_type,
          })),
        };
        const gssResponse = await dispatch(CreateGssReports(gssBody)).unwrap();
        setGssData(gssResponse?.data || {});
        setShowGss(true);
      }
    } else {
      const claimTypes = [
        ...new Set(selectedTableRow.map((r) => r.claim_type)),
      ];
      const insuranceIds = [
        ...new Set(selectedTableRow.map((r) => r.insurance_company_id)),
      ];

      if (insuranceIds.length > 1 && claimTypes.length > 1) {
        setGssDescription(
          "You can create a GSS report for only one claim type and one insurance conpmay at a time.",
        );
        setGssError(true);
      } else if (insuranceIds.length > 1) {
        setGssDescription(
          "You can create a GSS report for only one Insurance company at a time",
        );
        setGssError(true);
      } else if (claimTypes.length > 1) {
        setGssDescription(
          "You can create a GSS report for only one claim type at a time. Please select either Professional, Institutional, Vision, or Dental — but not more than one.",
        );
        setGssError(true);
      } else {
        const gssBody = {
          branch_id:
            claimFilters?.branch?.branch_id ||
            selectedBranch?.branch_id ||
            selectedBranch?.value ||
            "",
          insurance_company_id: selectedTableRow?.[0]?.insurance_company_id,
          claim_type: selectedTableRow?.[0]?.claim_type || "",
          claimsub_types_name: selectedTableRow?.[0]?.claim_sub_type || "",
          claim_data: selectedTableRow?.map((item) => ({
            claimid: item?.claimid || "",
            claim_type: item?.claim_type,
          })),
        };
        const gssResponse = await dispatch(CreateGssReports(gssBody)).unwrap();

        setGssData(gssResponse?.data || {});
        setShowGss(true);
      }
    }

    // If a row is selected
    // setShowGss(true);
  };

  const handleSelectTaxInvoice = async () => {
    if (!selectedTableRow || selectedTableRow.length === 0) {
      let hasFieldErrors = false;

      let requiredFields = ["payer", "insurance", "start_date", "end_date"];

      if (userData?.employee?.syspri_id === 1) {
        requiredFields.push("branch");
      }

      requiredFields.forEach((field) => {
        const value = watch(field);
        if (!value) {
          setError(field, {
            type: "manual",
            message: `${field.replace("_", " ")} is required`,
          });
          hasFieldErrors = true;
        }
      });

      if (hasFieldErrors) {
        toast.error(
          "Please fill required fields before generating tax invoice report",
        );
        return;
      } else {
        const excelBody = requestBody(page, totalRows);
        const response = await dispatch(GetAllClaimsList(excelBody)).unwrap();
        const allClaims = response?.data?.claim_data || [];

        const taxBody = {
          branch_id:
            claimFilters?.branch?.branch_id ||
            selectedBranch?.branch_id ||
            selectedBranch?.value ||
            "",
          insurance_company_id:
            claimFilters?.insurance?.insurance_company_id || "",
          claim_data: allClaims?.map((item) => ({
            claimid: item?.claimid || "",
            claim_type: item?.claim_type,
          })),
        };
        const taxResponse = await dispatch(
          CreateTaxInvoiceReports(taxBody),
        ).unwrap();
        setTaxData(taxResponse?.data || {});
        setShowTax(true);
      }
    } else {
      const insuranceIds = [
        ...new Set(selectedTableRow.map((r) => r.insurance_company_id)),
      ];

      if (insuranceIds.length > 1) {
        setGssDescription("Tax Invoice  Created only for one insurance");
        setGssError(true);
      } else {
        const taxBody = {
          branch_id:
            claimFilters?.branch?.branch_id ||
            selectedBranch?.branch_id ||
            selectedBranch?.value ||
            "",
          insurance_company_id: selectedTableRow?.[0]?.insurance_company_id,
          claim_data: selectedTableRow?.map((item) => ({
            claimid: item?.claimid || "",
            claim_type: item?.claim_type,
          })),
        };
        const taxResponse = await dispatch(
          CreateTaxInvoiceReports(taxBody),
        ).unwrap();
        setTaxData(taxResponse?.data || {});
        setShowTax(true);
      }
    }
    // setShowTax(true);
  };

  useEffect(() => {
    dispatch(handleResetCreateClaim());
    dispatch(handleResetAll({ check: "reset" }));
    dispatch(handleResetServices());
  }, []);

  useEffect(() => {
    fetchCliamsList(requestBody(page, rowsPerPage));
  }, [page, rowsPerPage]);

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0);
  }, []);

  const handleCheckListFilter = () => {
    setPage(0);
    fetchCliamsList(requestBody(0, 10));
  };

  const handleReset = async () => {
    const defaultBranch = selectedBranch
      ? {
          branch_name: selectedBranch.label || selectedBranch.branch_name,
          branch_id: selectedBranch.value || selectedBranch.branch_id,
          branch_cchino: selectedBranch.cchi || selectedBranch.branch_cchino,
        }
      : null;

    reset({
      branch: defaultBranch,
      branch_id: "",
      payer_id: "",
      insurance_company_id: "",
      claim_type: "",
      claimsub_types_name: "",
      bndle_reqid: "",
      frm_dte: "",
      to_dte: "",
      claimid: "",
      is_communication: false,
      is_secondresponse: false,
      ident_typ: "",
      pat_det: "",
      claim_sts: "",
    });
    setPage(0);
    setRowsPerPage(10);
    dispatch(handleResetFilter());

    if (defaultBranch) {
      dispatch(handleClaimFilter({ check: "branch", value: defaultBranch }));
    }

    const resetBody = {
      branch_id: defaultBranch?.branch_id || "",
      payer_id: "",
      insurance_company_id: "",
      claim_type: "",
      claimsub_types_name: "",
      bndle_reqid: "",
      frm_dte: "",
      to_dte: "",
      claimid: "",
      is_communication: false,
      is_secondresponse: false,
      ident_typ: "",
      pat_det: "",
      claim_sts: "",
      start_point: 0,
      limit: 10,
    };
    dispatch(GetAllClaimsList(resetBody)).unwrap();
  };

  // 🎯 Custom Dropdown Component (No react-bootstrap)
  const CustomDropdown = ({ children }) => {
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setOpen((prev) => !prev);

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    return (
      <div
        className="custom-dropdown card"
        ref={dropdownRef}
        style={{ position: "relative" }}
      >
        <Button
          size="sm"
          variant="warning"
          onClick={toggleDropdown}
          className="d-flex align-items-center"
        >
          <FiDownloadCloud className="me-2 fs-11" />
          Reports
        </Button>

        {open && (
          <div
            className="dropdown-menu p-0 show"
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              borderRadius: "4px",
              minWidth: "200px",
              zIndex: 1000,
            }}
          >
            {children}
          </div>
        )}
      </div>
    );
  };

  const DropdownItem = ({ icon: Icon, text, onClick, disabled = false }) => (
    <div
      className={`dropdown-item d-flex fs-10 fw-normal align-items-center gap-1 ${
        disabled ? "opacity-50" : ""
      }`}
      style={{
        padding: "4px 12px",
        cursor: disabled ? "not-allowed" : "pointer",
        pointerEvents: disabled ? "none" : "auto",
      }}
      onClick={!disabled ? onClick : undefined}
    >
      <Icon className="me-2" />
      <span>{text}</span>
    </div>
  );

  return (
    <>
      {Number(claimsSetting?.list) === 1 ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleCheckListFilter)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header className="d-flex fixed-header justify-content-between align-items-center">
              <Col xs="auto m-0">
                <h5 className="text-primary mb-0 fs-10">Claims List</h5>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <Button type="submit" size="sm" variant="success">
                  Filter
                </Button>

                {/* ✅ Custom Dropdown */}
                {(Number(claimsSetting?.export) === 1 ||
                  Number(claimsSetting?.print) === 1) && (
                  <CustomDropdown>
                    {Number(claimsSetting?.export) === 1 && (
                      <>
                        <DropdownItem
                          icon={FaFileExcel}
                          text="Claim Report"
                          disabled={!claimListData?.length}
                          onClick={handleDownloadClaimExcel}
                        />
                        <DropdownItem
                          icon={FaFileExcel}
                          text="Claim Service Report"
                          disabled={!claimListData?.length}
                          onClick={handleDownloadClaimServiceExcel}
                        />
                      </>
                    )}
                    {Number(claimsSetting?.print) === 1 && (
                      <>
                        <DropdownItem
                          icon={BsFilePdf}
                          text="Tax Invoice Report"
                          disabled={!claimListData?.length}
                          onClick={handleSelectTaxInvoice}
                        />
                        <DropdownItem
                          icon={BsFilePdf}
                          text="GSS Report"
                          disabled={!claimListData?.length}
                          onClick={handleGssReport}
                        />
                      </>
                    )}
                    {Number(claimsSetting?.export) === 1 && (
                      <DropdownItem
                        icon={FaFileExcel}
                        text="Deleted Claim Report"
                        onClick={handleDownloadDeletedServiceExcel}
                      />
                    )}
                  </CustomDropdown>
                )}
              </Col>
            </FalconComponentCard.Header>

            <FalconComponentCard.Body style={{ marginTop: "40px" }}>
              <Row>
                <Col xs={12} md={6} xl={8}>
                  <CliamsListFilter
                    watch={watch}
                    isSubmitted={isSubmitted}
                    setValue={setValue}
                    control={control}
                    errors={errors}
                    clearErrors={clearErrors}
                  />
                </Col>

                <Col xs={12} md={6} xl={4}>
                  <CliamsInformations
                    statusCounts={statusCounts}
                    totalRows={totalRows}
                    total={total}
                  />
                </Col>

                <Col xs={12}>
                  <ClaimListTable
                    data={claimListData}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    handlePageChange={handlePageChange}
                    handlePerRowsChange={handlePerRowsChange}
                    totalRows={totalRows}
                    setTotal={setTotal}
                    requestBody={requestBody}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    setStatusCounts={setStatusCounts}
                    setError={setError}
                    setTotalRows={setTotalRows}
                  />
                </Col>
              </Row>
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view Claims list.
          </p>
        </div>
      )}
      {showGss && (
        <PrintComponent
          print={""} // This might need to be updated based on your actual printing logic
          onPrintOpen={() => {
            setShowGss(false);
          }} // Close when done
          child={
            <ClaimGssReportPdf
              printData={gssData}
              claimFilters={claimFilters}
              printName={userData?.employee?.emp_name}
            />
          } // Ensure this component is properly set up to render the PDF
        />
      )}
      {showTax && (
        <PrintComponent
          print={""} // This might need to be updated based on your actual printing logic
          onPrintOpen={() => setShowTax(false)} // Close when done
          child={
            <TaxInvoicePdf
              printData={taxData}
              claimFilters={claimFilters}
              printName={userData?.employee?.emp_name}
            />
          } // Ensure this component is properly set up to render the PDF
        />
      )}
      <WizardModal
        modal={gssError}
        setModal={setGssError}
        title="Invalid Selection"
        description={gssDescription}
      />
    </>
  );
};

export default Cliams;
